import jishikaijiang from '../../Jishikaijiang/columns/pk10';
export default {
  list: Vue => {
    return jishikaijiang().list(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/pk10.js